module.exports = __webpack_public_path__ + "static/media/Rangeval.2df1ff8c.svg";